export const API_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? 'http://localhost:5001'
  : 'https://dpass.architectcrm.in';
export const BASE_URL = `${API_URL}/api/invoices`;

// Get auth token from localStorage
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const token = user.token || localStorage.getItem("authToken") || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchInvoices = async (search = "", filter = "all", startDate = "", endDate = "") => {
  const query = new URLSearchParams();
  if (search) query.append("search", search);
  if (filter) query.append("filter", filter);
  if (startDate) query.append("startDate", startDate);
  if (endDate) query.append("endDate", endDate);


  const res = await fetch(`${BASE_URL}?${query.toString()}`, {
    headers: {
      ...getAuthHeader(),
    },
  });
  return res.json();
};

export const createInvoice = async (formData) => {
  const res = await fetch(BASE_URL, {
    method: "POST",
    body: formData,
    headers: {
      ...getAuthHeader(),
    },
  });
  return res.json();
};

export const updateInvoice = async (id, formData) => {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: formData,
    headers: {
      ...getAuthHeader(),
    },
  });
  return res.json();
};

export const deleteInvoice = async (id) => {
  return fetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: {
      ...getAuthHeader(),
    },
  }).then(res => res.json());
};
